import { useState } from 'react';
import posthog from 'posthog-js';
import useMountEffect from '../../hooks/useMountEffect';
import { AGENT_CHAT_FEATURE_FLAG } from '../../utils/EnvConfigUtils';

const readFlag = (): boolean => !!posthog.isFeatureEnabled(AGENT_CHAT_FEATURE_FLAG);

/**
 * Whether Oscar is on for this user — the `agent-chat` PostHog flag, the same
 * one that reveals the menu items in `EnvConfigUtils`.
 *
 * Read into state and subscribed, not read during render. `session_thunks`
 * renders the app before `ThirdPartyService.boot` calls `posthog.identify`, so
 * the first evaluation is anonymous — and if that came back false, nothing
 * re-rendered when the real flags landed. An enabled user simply never saw
 * Oscar until some unrelated update happened to refresh the component.
 */
const useAgentChatEnabled = (): boolean => {
	const [enabled, setEnabled] = useState(readFlag);

	useMountEffect(() => {
		setEnabled(readFlag());
		return posthog.onFeatureFlags(() => setEnabled(readFlag()));
	});

	return enabled;
};

export default useAgentChatEnabled;
